import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const s = {
  page: { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
    background:'linear-gradient(135deg,#0A1628 0%,#1a2332 50%,#0A1628 100%)' },
  card: { background:'rgba(15,23,42,0.95)', border:'1px solid rgba(0,217,255,0.2)',
    borderRadius:20, padding:'50px 40px', width:'100%', maxWidth:420,
    boxShadow:'0 20px 60px rgba(0,0,0,0.5),0 0 80px rgba(0,217,255,0.1)' },
  title: { fontSize:28, fontWeight:700, textAlign:'center', marginBottom:8,
    background:'linear-gradient(135deg,#fff 0%,#00D9FF 100%)',
    WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' },
  sub: { textAlign:'center', color:'#94a3b8', marginBottom:36, fontSize:14 },
  label: { display:'block', marginBottom:6, fontSize:13, color:'#94a3b8' },
  input: { width:'100%', padding:'12px 16px', borderRadius:10, border:'1px solid rgba(255,255,255,0.15)',
    background:'rgba(255,255,255,0.05)', color:'#fff', fontSize:15, outline:'none',
    marginBottom:20 },
  btn: { width:'100%', padding:'14px', borderRadius:12, border:'none', cursor:'pointer',
    background:'linear-gradient(135deg,#00D9FF 0%,#0099cc 100%)', color:'#fff',
    fontSize:16, fontWeight:600, marginTop:8 },
  err: { padding:'10px 14px', borderRadius:8, background:'rgba(239,68,68,0.1)',
    border:'1px solid rgba(239,68,68,0.3)', color:'#fca5a5', fontSize:13,
    marginBottom:16, textAlign:'center' },
};

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.title}>Anise</div>
        <div style={s.sub}>AI-Native SaaS Platform</div>
        {error && <div style={s.err}>{error}</div>}
        <form onSubmit={submit}>
          <label style={s.label}>Email</label>
          <input style={s.input} type="email" value={email}
            onChange={e => setEmail(e.target.value)} required autoFocus />
          <label style={s.label}>Password</label>
          <input style={s.input} type="password" value={password}
            onChange={e => setPassword(e.target.value)} required />
          <button style={s.btn} type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
